/**
 * Post Slider Frontend Interactions
 */

document.addEventListener('DOMContentLoaded', function() {
	// Check if document and required APIs are available
	if (!document || typeof document.querySelectorAll !== 'function') {
		return;
	}

	const sliders = document.querySelectorAll('.wp-block-wwx-block-post-slider');
	
	if (!sliders || sliders.length === 0) {
		return;
	}
	
	sliders.forEach(function(slider) {
		if (slider && slider.nodeType === Node.ELEMENT_NODE) {
			initializeSlider(slider);
		}
	});
});

function initializeSlider(sliderElement) {
	// Validate slider element exists and is a proper element
	if (!sliderElement || sliderElement.nodeType !== Node.ELEMENT_NODE) {
		return;
	}

	const slides = sliderElement.querySelectorAll('.post-slider-slide');
	const dots = sliderElement.querySelectorAll('.post-slider-dot');
	const prevArrow = sliderElement.querySelector('.post-slider-arrow-prev');
	const nextArrow = sliderElement.querySelector('.post-slider-arrow-next');
	const container = sliderElement.querySelector('.post-slider-container');
	
	// Ensure we have required elements
	if (!slides || slides.length === 0 || !container || container.nodeType !== Node.ELEMENT_NODE) {
		return;
	}
	
	let currentSlide = 0;
	let autoplayInterval = null;
	let isTransitioning = false;
	let transitionTimerId = null;

	function resetTransitionState() {
		// Cancel any pending cleanup and remove transitional classes so we can respond immediately
		if (transitionTimerId) {
			clearTimeout(transitionTimerId);
			transitionTimerId = null;
		}
		isTransitioning = false;
		if (slides && slides.forEach) {
			slides.forEach((s) => {
				if (!s || !s.classList) return;
				s.classList.remove('transitioning-in');
				s.classList.remove('background');
				// Remove any animation-* class for safety
				Array.from(s.classList)
					.filter((c) => c && c.indexOf('animation-') === 0)
					.forEach((c) => s.classList.remove(c));
			});
		}
	}
	
	// Get settings from data attributes (set by PHP)
	const autoplay = sliderElement.dataset.autoplay === 'true';
	const autoplaySpeed = parseInt(sliderElement.dataset.autoplaySpeed) || 5000;
	const maskAnimationDuration = parseInt(sliderElement.dataset.maskAnimationDuration) || 1600;
	const borderRadius = parseInt(sliderElement.dataset.borderRadius) || 12;
	const heightDesktop = parseInt(sliderElement.dataset.heightDesktop) || 500;
	const heightTablet = parseInt(sliderElement.dataset.heightTablet) || 400;
	const heightMobile = parseInt(sliderElement.dataset.heightMobile) || 300;
	const animationType = sliderElement.dataset.animationType || 'circle';
	const showDots = sliderElement.dataset.showDots !== 'false';
	const showArrows = sliderElement.dataset.showArrows !== 'false';
	const enableContentAnimation = sliderElement.dataset.enableContentAnimation !== 'false';
	const contentAnimationType = sliderElement.dataset.contentAnimationType || 'fadeUp';
	const contentAnimationDuration = parseInt(sliderElement.dataset.contentAnimationDuration) || 800;
	const contentAnimationDelay = parseInt(sliderElement.dataset.contentAnimationDelay) || 400;
	const titleAnimationDelay = parseInt(sliderElement.dataset.titleAnimationDelay) || 200;
	const excerptAnimationDelay = parseInt(sliderElement.dataset.excerptAnimationDelay) || 400;
	const buttonAnimationDelay = parseInt(sliderElement.dataset.buttonAnimationDelay) || 600;
	
	// Apply CSS custom properties for styling
	if (sliderElement.style && typeof sliderElement.style.setProperty === 'function') {
		sliderElement.style.setProperty('--mask-animation-duration', maskAnimationDuration + 'ms');
		sliderElement.style.setProperty('--slider-height-desktop', heightDesktop + 'px');
		sliderElement.style.setProperty('--slider-height-tablet', heightTablet + 'px');
		sliderElement.style.setProperty('--slider-height-mobile', heightMobile + 'px');
		sliderElement.style.setProperty('--slider-border-radius', borderRadius + 'px');
		sliderElement.style.setProperty('--content-animation-duration', contentAnimationDuration + 'ms');
		sliderElement.style.setProperty('--content-animation-delay', contentAnimationDelay + 'ms');
		sliderElement.style.setProperty('--title-animation-delay', titleAnimationDelay + 'ms');
		sliderElement.style.setProperty('--excerpt-animation-delay', excerptAnimationDelay + 'ms');
		sliderElement.style.setProperty('--button-animation-delay', buttonAnimationDelay + 'ms');
	}
	
	function setupContentAnimation(slide) {
		if (!enableContentAnimation || !slide || !slide.classList) {
			return;
		}

		slide.classList.add('content-animated');
		
		const title = slide.querySelector('.post-slider-title');
		const excerpt = slide.querySelector('.post-slider-excerpt');
		const button = slide.querySelector('.post-slider-read-more');
		
		if (title && title.classList) {
			title.classList.add('content-animation', 'content-' + contentAnimationType);
		}

		if (excerpt && excerpt.classList) {
			excerpt.classList.add('content-animation', 'content-' + contentAnimationType);
		}
		
		if (button && button.classList) {
			button.classList.add('content-animation', 'content-' + contentAnimationType);
		}
	}
	
	function goToSlide(index, force = false) {
		if ((isTransitioning && !force) || index === currentSlide || index >= slides.length || index < 0) {
			return;
		}

		// If we're mid-transition and this is a user-forced action, reset state immediately
		if (force && isTransitioning) {
			resetTransitionState();
		}
		
		isTransitioning = true;
		const previousSlide = currentSlide;
		
		// Set previous slide as background (stays visible during transition)
		if (slides[previousSlide] && slides[previousSlide].classList) {
			slides[previousSlide].classList.remove('active');
			slides[previousSlide].classList.add('background');
		}
		
		// Remove active class from previous dot
		if (dots[previousSlide] && dots[previousSlide].classList) {
			dots[previousSlide].classList.remove('active');
		}
		
		// Prepare new slide for transition
		if (slides[index] && slides[index].classList) {
			// Remove any existing classes
			slides[index].classList.remove('active', 'background');
			slides[index].classList.add('transitioning-in', 'animation-' + animationType);
			
			// Setup content animation for new slide
			setupContentAnimation(slides[index]);
			
			// Use requestAnimationFrame for smooth animation
			if (typeof requestAnimationFrame === 'function') {
				requestAnimationFrame(() => {
					// Set new active slide and dot immediately
					if (slides[index] && slides[index].classList) {
						slides[index].classList.add('active');
					}
					if (dots[index] && dots[index].classList) {
						dots[index].classList.add('active');
					}
					currentSlide = index;
					
					// Clean up after animation completes
					transitionTimerId = setTimeout(() => {
						// Remove transition classes from new slide
						if (slides[index] && slides[index].classList) {
							slides[index].classList.remove('transitioning-in', 'animation-' + animationType);
						}
						
						// Remove background class from previous slide
						if (slides[previousSlide] && slides[previousSlide].classList) {
							slides[previousSlide].classList.remove('background');
						}
						
						isTransitioning = false;
						transitionTimerId = null;
					}, maskAnimationDuration);
				});
			} else {
				// Fallback for browsers without requestAnimationFrame
				if (slides[index] && slides[index].classList) {
					slides[index].classList.add('active');
				}
				if (dots[index] && dots[index].classList) {
					dots[index].classList.add('active');
				}
				currentSlide = index;
				
				// Clean up without animation
				transitionTimerId = setTimeout(() => {
					if (slides[index] && slides[index].classList) {
						slides[index].classList.remove('transitioning-in', 'animation-' + animationType);
					}
					if (slides[previousSlide] && slides[previousSlide].classList) {
						slides[previousSlide].classList.remove('background');
					}
					isTransitioning = false;
					transitionTimerId = null;
				}, 50);
			}
		}
	}
	
	function nextSlide() {
		if (slides.length <= 1) {
			return;
		}
		const next = (currentSlide + 1) % slides.length;
		goToSlide(next);
	}

	function prevSlide() {
		if (slides.length <= 1) {
			return;
		}
		const prev = currentSlide === 0 ? slides.length - 1 : currentSlide - 1;
		goToSlide(prev);
	}
	
	function startAutoplay() {
		if (!autoplay || slides.length <= 1) {
			return;
		}
		
		autoplayInterval = setInterval(nextSlide, autoplaySpeed);
	}
	
	function stopAutoplay() {
		if (autoplayInterval) {
			clearInterval(autoplayInterval);
			autoplayInterval = null;
		}
	}
	
	// Initialize first slide if it exists
	if (slides[0] && slides[0].classList) {
		slides[0].classList.add('active');
		setupContentAnimation(slides[0]);
	}
	if (dots[0] && dots[0].classList) {
		dots[0].classList.add('active');
	}
	
	// Set up dot navigation
	if (dots && dots.length > 0 && showDots) {
		dots.forEach((dot, index) => {
			if (!dot || !dot.addEventListener) return;
			
				dot.addEventListener('click', (e) => {
				if (e && e.preventDefault) {
					e.preventDefault();
				}
				stopAutoplay();
					// Force immediate response even if a transition is running
					goToSlide(index, true);
				// Restart autoplay after manual interaction
				setTimeout(startAutoplay, 3000);
			});

				dot.addEventListener('keydown', (e) => {
				if (!e) return;
				if (e.key === 'Enter' || e.key === ' ') {
					if (e.preventDefault) e.preventDefault();
					stopAutoplay();
						goToSlide(index, true);
					// Restart autoplay after manual interaction
					setTimeout(startAutoplay, 3000);
				}
			});
		});
	}

	// Set up arrow navigation
		if (showArrows && slides.length > 1) {
		if (prevArrow && prevArrow.addEventListener) {
			prevArrow.addEventListener('click', (e) => {
				if (e && e.preventDefault) {
					e.preventDefault();
				}
				stopAutoplay();
					// Go to previous immediately if mid-transition
					goToSlide(currentSlide === 0 ? slides.length - 1 : currentSlide - 1, true);
				// Restart autoplay after manual interaction
				setTimeout(startAutoplay, 3000);
			});
		}

			if (nextArrow && nextArrow.addEventListener) {
			nextArrow.addEventListener('click', (e) => {
				if (e && e.preventDefault) {
					e.preventDefault();
				}
				stopAutoplay();
					// Go to next immediately if mid-transition
					goToSlide((currentSlide + 1) % slides.length, true);
				// Restart autoplay after manual interaction
				setTimeout(startAutoplay, 3000);
			});
		}
	}
	
	// Pause autoplay on hover
	if (container && container.addEventListener) {
		container.addEventListener('mouseenter', stopAutoplay);
		container.addEventListener('mouseleave', startAutoplay);
	}
	
	// Touch/swipe support for mobile
	let touchStartX = 0;
	let touchEndX = 0;
	
	if (container && container.addEventListener) {
		container.addEventListener('touchstart', (e) => {
			if (e && e.changedTouches && e.changedTouches[0]) {
				touchStartX = e.changedTouches[0].screenX;
			}
		}, { passive: true });
		
		container.addEventListener('touchend', (e) => {
			if (e && e.changedTouches && e.changedTouches[0]) {
				touchEndX = e.changedTouches[0].screenX;
				handleSwipe();
			}
		}, { passive: true });
	}
	
	function handleSwipe() {
		const swipeThreshold = 50;
		const diff = touchStartX - touchEndX;
		
		if (Math.abs(diff) > swipeThreshold && slides.length > 1) {
			stopAutoplay();
			
			if (diff > 0) {
				// Swipe left - next slide
				goToSlide((currentSlide + 1) % slides.length, true);
			} else {
				// Swipe right - previous slide
				goToSlide(currentSlide === 0 ? slides.length - 1 : currentSlide - 1, true);
			}
			
			// Restart autoplay after swipe
			setTimeout(startAutoplay, 3000);
		}
	}
	
	// Keyboard navigation
	if (container && container.addEventListener) {
		container.addEventListener('keydown', (e) => {
			if (slides.length <= 1 || !e) {
				return;
			}
			
			if (e.key === 'ArrowLeft') {
				if (e.preventDefault) e.preventDefault();
				stopAutoplay();
				goToSlide(currentSlide === 0 ? slides.length - 1 : currentSlide - 1, true);
				setTimeout(startAutoplay, 3000);
			} else if (e.key === 'ArrowRight') {
				if (e.preventDefault) e.preventDefault();
				stopAutoplay();
				goToSlide((currentSlide + 1) % slides.length, true);
				setTimeout(startAutoplay, 3000);
			}
		});
	}
	
	// Make container focusable for keyboard navigation
	if (container && (container.tabIndex === undefined || container.tabIndex < 0)) {
		container.tabIndex = 0;
	}
	
	// Start autoplay
	startAutoplay();
	
	// Pause when page is not visible
	if (document && document.addEventListener) {
		document.addEventListener('visibilitychange', () => {
			if (document.hidden) {
				stopAutoplay();
			} else {
				startAutoplay();
			}
		});
	}
}